<template>
<div class="news-index">
  <div class="main-inner">
    <main>
      <section class="list-box" v-if="!this.confirmWithdraw && !this.withDrawalCompleted && !this.withDrawalError">
        <h3 class="headline2 mb-10">退会のお手続き</h3>
        <h3 class="headline2 mb-10" style="display: flex; justify-content: center;">退会手続きの前にご確認ください</h3>
        <div class="scroll-box" style="height: 280px">
          <ul class="c-list--disc">
            <li class="c-list--disc-item">退会手続きが完了しますと、会員期限を以って「食のトレンド情報 Web」のアカウントは無効となり、登録した個人情報、ブックマークに保存したデータ等はすべて抹消されます。再び、会員登録をされても復旧はできませんのでご了承ください。</li>
            <li class="c-list--disc-item">購読料のご返金は一切できません。</li>
            <li class="c-list--disc-item">退会完了後は、弊社はお客様に関する一切の情報を保持していないため、ブックマークに保存したデータの内容等についてお問い合わせいただいてもお答えできません。</li>
            <li class="c-list--disc-item">退会日時は、お支払い方法によって変わります。下記リンク先の「Q 退会手続きの期限と退会日時を教えてください。」をご確認ください。</li>
          </ul>
          <br>
          <a v-bind:href="domain + '/faq#link_c'" target="_blank" class="faq-link">
            Q 退会手続きの期限と退会日時を教えてください。<img class="window-icon" src="../../../static/icon-windows.png">
          </a>
        </div>
        <p class="check-agree"><label><input type="checkbox" v-model="checked">上記注意事項に同意の上、退会手続きを行います</label></p>
        <div class="btn-set">
          <span class="btn-gray2"><button @click="$router.push('setting')">キャンセル</button></span>
          <span v-bind:class="[checked ? 'btn-gray2' : 'btn-gray']"><button @click="confirmBtnClick()" :disabled="!checked">次へ</button></span>
        </div>
      </section>

      <section class="list-box" v-if="this.confirmWithdraw && !this.withDrawalCompleted && !this.withDrawalError">
        <h3 class="headline2 mb-10">退会のお手続き</h3>
        <h3 class="headline2 mb-10">下記項目をご入力ください。</h3>
        <p>【退会する】ボタンを押すと退会のお手続きが完了となります。</p>
        <p>一度ボタンを押すと、取り消しができませんのでご注意ください。</p>
        <br>
        <div class="scroll-box withdrawal-box">
          <h4 class="headline2 mb-10">ご登録メールアドレス</h4>
          <p>
              {{ corporation.email }}
          </p>
          <h4 class="headline2 mb-10">パスワード</h4>
          <input :type="inputType" name="password" v-model="password" style="width:15%;" class="input">
          <span class="input-icon">
            <span :class="iconType" @click="onClick"><img class="password-icon" src="../../../static/icon_login.png"></span>
          </span>
          <br>
          <small class="text-error util-line-height-none" v-if="displayErrorMessage">{{ errorMessage }}</small>
          <h4 class="headline2 mb-10">退会理由（恐れ入りますが、サービス向上のためご協力ください）</h4>
          <div v-for="(reason, index) in reasonList" :key="index">
            <input :id="'reason'+index" type="checkbox" v-bind:value="reason" v-model="reasons">
            <label :for="'reason'+index">{{ reason }}</label>
          </div>
          <textarea placeholder="例）その他詳細内容" name="otherReason" v-model="otherReason" class="withdrawal-text">
          </textarea>
        </div>
        <br>
        <div class="btn-set">
          <span class="btn-gray2"><button @click="returnBtnClick()">前の画面に戻る</button></span>
          <span class="btn-gray2"><button @click="withDrawal()">退会する</button></span>
        </div>
      </section>

      <section class="list-box" v-if="this.withDrawalCompleted">
        <h3 class="headline2 mb-10">退会完了</h3>
        <h3 class="headline2 mb-10" style="display: flex; justify-content: center;">退会のお手続きが完了しました</h3>
        <p style="display: flex; justify-content: center;">「食のトレンド情報 Web」をご購読いただき、誠にありがとうございました。</p>
        <p style="display: flex; justify-content: center;">退会手続き完了のメールをお送りいたしましたのでご確認ください。またのご利用を心よりお待ちしております。</p>
        <p v-if="tempCorporation.contractPeriodTo !== null" style="display: flex; justify-content: center;">尚、会員期限の{{contractPeriodTo.getFullYear()}}年{{contractPeriodTo.getMonth() + 1}}月{{contractPeriodTo.getDate()}}日までは、このままご利用いただけます。</p><br>
        <p style="display: flex; justify-content: center;">個人向けプランから法人向けプランへ、法人向けプランから個人向けプランへ、一度退会して再度入会をご希望のお客様は、<br>下記よりお手続きをお願いいたします。</p><br>
        <div class="withdrawal-login">
          <a style="display: flex; justify-content: center;" v-bind:href="domain + '/register/individual'" class="faq-link">
            個人の新規会員登録はこちら<img src="../../../static/icon_arrow.png" class="arrow-icon">
          </a>
        </div><br>
        <div class="withdrawal-login">
          <a style="display: flex; justify-content: center;" v-bind:href="domain + '/register/corporation'" class="faq-link">
            法人の新規会員登録はこちら<img src="../../../static/icon_arrow.png" class="arrow-icon">
          </a>
        </div>
        <br>
        <div v-if="tempCorporation.contractPeriodTo === null" class="btn-set">
          <span class="btn-gray2"><button @click="$router.push('login')">ログインページへ</button></span>
        </div>
        <div v-else class="btn-set">
          <span class="btn-gray2"><button @click="$router.push('setting')">管理者情報に戻る</button></span>
        </div>
      </section>

      <section class="list-box" v-if="this.withDrawalError">
        <h3 class="headline2 mb-10" style="display: flex; justify-content: center;">退会に失敗しました。</h3>
        <p style="display: flex; justify-content: center;">お手数ですが、お問い合わせフォームからお問い合わせいただきますよう、お願いいたします。</p>
        <br>
        <div class="btn-set">
          <span class="btn-gray2"><a v-bind:href="domain + '/contact'" class="faq-link" style="color:white;border-radius:23px;">お問い合わせフォーム</a></span>
        </div>
      </section>
    </main>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { parseApierror } from '../../util/utils'
import httpResource from '../../http/httpResource'
import Processing from '../../util/processing'
import store from '../../store/index'
export default {
  mixins: [Processing],
  name: 'Payment',
  data () {
    return {
      domain: process.env.DOMAIN,
      tempCorporation: {},
      contractPeriodTo: '',
      reasonList: [
        '業務内容が変わったから',
        '欲しい情報が得られないから',
        '活用されていないようだから',
        '利用料が高いから',
        '他のサービスに変えるから',
        'その他（詳細は下記にご記入ください）'
      ],
      otherReason: '',
      confirmWithdraw: false,
      checked: false,
      isChecked: false,
      reasons: [],
      password: '',
      displayErrorMessage: false,
      errorMessage: '',
      withDrawalCompleted: false,
      withDrawalError: false
    }
  },
  mounted () {
    this.reloadData()
  },
  methods: {
    returnBtnClick () {
      this.confirmWithdraw = false
      this.errorMessage = ''
      this.password = ''
      this.checked = false
    },
    confirmBtnClick () {
      this.confirmWithdraw = true
    },
    async reloadData () {
      try {
        const response = await httpResource.get('/corporation/info', {headers: {Authorization: `Bearer ${store.getters.getAuthData.token}`}})
        if (response.status === 200) {
          const data = response.data
          this.tempCorporation = data
          this.contractPeriodTo = new Date(this.tempCorporation.contractPeriodTo)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async withDrawal () {
      const withdrawlForm = {
        password: this.password,
        reasons: this.reasons,
        otherReason: this.otherReason
      }
      try {
        const response = await httpResource.post('/corporation/withdrawal', withdrawlForm, {headers: {Authorization: `Bearer ${store.getters.getAuthData.token}`}})
        if (response.status === 200) {
          if (response.data.message === 'SUCCESS') {
            this.withDrawalCompleted = true
            if (this.tempCorporation.contractPeriodTo === null) {
              store.dispatch('logout')
            }
          } else {
            this.withDrawalError = true
          }
        }
      } catch (error) {
        const apierror = parseApierror(error)
        this.displayErrorMessage = true
        this.errorMessage = apierror.message
      }
      setTimeout(function () {
        // ボタンのロックを解除する
        this.endProcessing()
      }.bind(this), 2000)
    },
    onClick () {
      this.isChecked = !this.isChecked
    }
  },
  computed: {
    ...mapGetters({
      corporation: 'getCorporation'
    }),
    inputType: function () {
      return this.isChecked ? 'text' : 'password'
    },
    iconType: function () {
      return this.isChecked ? 'eye' : 'eye-slash'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/withdrawal/index.vue